function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { EventDispatcher } from "./Utils/EventDispatcher";
import { Loader } from "./Core/Loader";
import { Plugins } from "./Core/Utils/Plugins";
export var Engine = /*#__PURE__*/function () {
  function Engine() {
    _classCallCheck(this, Engine);

    this._domArray = [];
    this._eventDispatcher = new EventDispatcher();
    this._initialized = false;
    this._loader = new Loader(this);
    this.plugins = new Plugins(this);
  }

  _createClass(Engine, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      this._eventDispatcher.addEventListener(type, listener);
    }
  }, {
    key: "addInteractor",
    value: function () {
      var _addInteractor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, interactorInitializer) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.plugins.addInteractor(name, interactorInitializer);
                _context.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addInteractor(_x, _x2) {
        return _addInteractor.apply(this, arguments);
      }

      return addInteractor;
    }()
  }, {
    key: "addMover",
    value: function () {
      var _addMover = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, moverInitializer) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.plugins.addParticleMover(name, moverInitializer);
                _context2.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addMover(_x3, _x4) {
        return _addMover.apply(this, arguments);
      }

      return addMover;
    }()
  }, {
    key: "addParticleUpdater",
    value: function () {
      var _addParticleUpdater = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name, updaterInitializer) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.plugins.addParticleUpdater(name, updaterInitializer);
                _context3.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addParticleUpdater(_x5, _x6) {
        return _addParticleUpdater.apply(this, arguments);
      }

      return addParticleUpdater;
    }()
  }, {
    key: "addPathGenerator",
    value: function () {
      var _addPathGenerator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(name, generator) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.plugins.addPathGenerator(name, generator);
                _context4.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addPathGenerator(_x7, _x8) {
        return _addPathGenerator.apply(this, arguments);
      }

      return addPathGenerator;
    }()
  }, {
    key: "addPlugin",
    value: function () {
      var _addPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(plugin) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.plugins.addPlugin(plugin);
                _context5.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addPlugin(_x9) {
        return _addPlugin.apply(this, arguments);
      }

      return addPlugin;
    }()
  }, {
    key: "addPreset",
    value: function () {
      var _addPreset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(preset, options) {
        var override,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                override = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
                this.plugins.addPreset(preset, options, override);
                _context6.next = 4;
                return this.refresh();

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function addPreset(_x10, _x11) {
        return _addPreset.apply(this, arguments);
      }

      return addPreset;
    }()
  }, {
    key: "addShape",
    value: function () {
      var _addShape = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(shape, drawer, init, afterEffect, destroy) {
        var customDrawer;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (typeof drawer === "function") {
                  customDrawer = {
                    afterEffect: afterEffect,
                    destroy: destroy,
                    draw: drawer,
                    init: init
                  };
                } else {
                  customDrawer = drawer;
                }

                this.plugins.addShapeDrawer(shape, customDrawer);
                _context7.next = 4;
                return this.refresh();

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addShape(_x12, _x13, _x14, _x15, _x16) {
        return _addShape.apply(this, arguments);
      }

      return addShape;
    }()
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(type, args) {
      this._eventDispatcher.dispatchEvent(type, args);
    }
  }, {
    key: "dom",
    value: function dom() {
      return this._domArray;
    }
  }, {
    key: "domItem",
    value: function domItem(index) {
      var dom = this.dom(),
          item = dom[index];

      if (item && !item.destroyed) {
        return item;
      }

      dom.splice(index, 1);
    }
  }, {
    key: "init",
    value: function init() {
      if (!this._initialized) {
        this._initialized = true;
      }
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(tagId, options) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this._loader.load(tagId, options));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function load(_x17, _x18) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "loadFromArray",
    value: function () {
      var _loadFromArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(tagId, options, index) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this._loader.load(tagId, options, index));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function loadFromArray(_x19, _x20, _x21) {
        return _loadFromArray.apply(this, arguments);
      }

      return loadFromArray;
    }()
  }, {
    key: "loadJSON",
    value: function () {
      var _loadJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(tagId, pathConfigJson, index) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this._loader.loadJSON(tagId, pathConfigJson, index));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function loadJSON(_x22, _x23, _x24) {
        return _loadJSON.apply(this, arguments);
      }

      return loadJSON;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _iterator, _step, instance;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(this.dom());
                _context11.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context11.next = 9;
                  break;
                }

                instance = _step.value;
                _context11.next = 7;
                return instance.refresh();

              case 7:
                _context11.next = 3;
                break;

              case 9:
                _context11.next = 14;
                break;

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11["catch"](1);

                _iterator.e(_context11.t0);

              case 14:
                _context11.prev = 14;

                _iterator.f();

                return _context11.finish(14);

              case 17:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 11, 14, 17]]);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      this._eventDispatcher.removeEventListener(type, listener);
    }
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id, element, options) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this._loader.set(id, element, options));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function set(_x25, _x26, _x27) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "setJSON",
    value: function () {
      var _setJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id, element, pathConfigJson, index) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this._loader.setJSON(id, element, pathConfigJson, index));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setJSON(_x28, _x29, _x30, _x31) {
        return _setJSON.apply(this, arguments);
      }

      return setJSON;
    }()
  }, {
    key: "setOnClickHandler",
    value: function setOnClickHandler(callback) {
      var dom = this.dom();

      if (!dom.length) {
        throw new Error("Can only set click handlers after calling tsParticles.load() or tsParticles.loadJSON()");
      }

      var _iterator2 = _createForOfIteratorHelper(dom),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var domItem = _step2.value;
          domItem.addClickHandler(callback);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return Engine;
}();